import { s16 } from '@ardoq/design-tokens';
import { FOCUS_RING_SPREAD } from '@ardoq/style-helpers';
import styled from 'styled-components';
import { CHIPS_LIST_SELECTOR } from './ChipsList';

export const FiltersBar = styled.div`
  display: flex;
  justify-content: space-between;

  & > ${CHIPS_LIST_SELECTOR} {
    margin-top: ${-FOCUS_RING_SPREAD + 2}px;
    margin-right: ${s16};
  }
`;
